import React from 'react';

const Card = ({
  children,
  title,
  subtitle,
  action,
  className = '',
  padding = true,
}) => {
  const paddingClass = padding ? 'p-6' : '';

  return (
    <div className={`bg-white rounded-lg border border-gray-200 shadow-card ${className}`}>
      {(title || action) && (
        <div className={`flex items-center justify-between border-b border-gray-100 ${padding ? 'px-6 py-4' : 'p-4'}`}>
          <div>
            {title && <h3 className="text-base font-semibold text-gray-900">{title}</h3>}
            {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={paddingClass}>
        {children}
      </div>
    </div>
  );
};

export default Card;
